export const generateVideoTeaserUrl = (file: File): Promise<string> => {
  return new Promise((resolve) => {
    const fileReader = new FileReader();

    fileReader.onload = () => {
      if (!fileReader.result) {
        resolve('');
        return;
      }

      const blob = new Blob([fileReader.result], { type: file.type });

      const video = document.createElement('video');

      video.onloadedmetadata = function () {
        setTimeout(() => (video.currentTime = 3), 100);
      };

      video.onseeked = function () {
        const canvas = document.createElement('canvas');

        const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

        const { videoWidth, videoHeight } = video;

        canvas.height = videoHeight;

        if (videoHeight < videoWidth) {
          //* If the video is landscape, we can just set the canvas width to the video width.
          canvas.width = videoWidth;
        } else {
          //* If it's portrait, we need to add black bars on the sides to make it 16:9.
          const targetRatio = 16 / 9;

          const targetWidth = videoHeight * targetRatio;

          canvas.width = targetWidth;

          ctx.fillStyle = '#000';

          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        ctx.drawImage(video, (canvas.width - videoWidth) / 2, 0, videoWidth, videoHeight);

        resolve(canvas.toDataURL());
      };

      video.src = URL.createObjectURL(blob);
    };

    fileReader.readAsArrayBuffer(file);
  });
};
